import { Utils } from '@pbt/pbt-ui-components'
import {
  Environment,
  Region,
} from '@pbt/pbt-ui-components/src/constants/environment'
import { getDomainContext } from '@pbt/pbt-ui-components/src/utils'

const PublicWSMap: Record<Region, Partial<Record<Environment, string>>> = {
  [Region.US]: {
    [Environment.PROD]: 'wss://api.rhapsody.vet/subscriptions',
    [Environment.MASTER]: 'wss://api.master.rhapsody.vet/subscriptions',
    [Environment.STAGE]: 'wss://api.stage.rhapsody.vet/subscriptions',
  },
  [Region.EU]: {
    [Environment.PROD]: 'wss://api.eu.rhapsody.vet/subscriptions',
    [Environment.MASTER]: 'wss://api.eu.master.rhapsody.vet/subscriptions',
    [Environment.STAGE]: 'wss://api.eu.stage.rhapsody.vet/subscriptions',
  },
}

export const getGraphQLWsUrl = (): string => {
  try {
    const domainContext = getDomainContext()
    if (!domainContext || !domainContext.region) {
      return ''
    }

    // Resolve env/region, overriding from `window.pbt` in local dev
    let resolvedEnv = domainContext.env
    let resolvedRegion = domainContext.region
    if (Utils.isLocalEnvironment()) {
      try {
        resolvedEnv = (window as any)?.pbt?.getDevEnv?.() || resolvedEnv
        resolvedRegion =
          (window as any)?.pbt?.getDevRegion?.() || resolvedRegion
      } catch {
        // intentionally empty: optional local overrides
      }
    }

    const envApiMap = PublicWSMap[resolvedRegion]
    const defaultApiUrl = envApiMap?.[Environment.STAGE]
    const baseUrl = envApiMap?.[resolvedEnv] || defaultApiUrl || ''

    if (!baseUrl || !Utils.isLocalEnvironment()) return baseUrl

    // For local dev, include query params so gateway can route correctly
    const url = new URL(baseUrl)
    if (resolvedEnv) url.searchParams.set('pbtDevEnv', String(resolvedEnv))
    if (resolvedRegion)
      url.searchParams.set('pbtDevRegion', String(resolvedRegion))
    return url.toString()
  } catch {
    return ''
  }
}
